__turbopack_context__.v({
  "className": "fredoka_df19089e-module__liieuG__className",
});
